import { DateTime } from 'luxon';
import { TableOptions } from 'react-table';
export const dayAccessors = [
  'DAY_1',
  'DAY_2',
  'DAY_3',
  'DAY_4',
  'DAY_5',
  'DAY_6',
  'DAY_7',
  'DAY_8',
  'DAY_9',
  'DAY_10',
  'DAY_11',
  'DAY_12',
  'DAY_13',
  'DAY_14',
  'DAY_15',
  'DAY_16',
  'DAY_17',
  'DAY_18',
  'DAY_19',
  'DAY_20',
  'DAY_21',
  'DAY_22',
  'DAY_23',
  'DAY_24',
  'DAY_25',
  'DAY_26',
  'DAY_27',
  'DAY_28',
  'DAY_29',
  'DAY_30',
  'DAY_31',
] as const;
// Can later be extended to WEEK_ and MONTH_ accessors if needed

export type DayColumnAccessors = (typeof dayAccessors)[number];
//Ditto
export type CalendarModes = 'month';
export type CalendarGridProps<ColumnDefinition extends object, DateData extends object[]> = Omit<
  TableOptions<ColumnDefinition>,
  'data'
> & {
  mode: CalendarModes;
  data: (ColumnDefinition & { [key in DayColumnAccessors]: DateData | undefined })[];
  startDate: DateTime;
  cellFn: ({ value }: { value: DateData }) => JSX.Element;
  headerFn?: (...args: any[]) => JSX.Element;
};
